<template>
  <div class="myradio">
    <el-main :style="toolsBoxStyle">
      <el-row align="middle">
        <el-radio-group v-model="graphMode" @change="radioChangeTool">
          <el-radio-button
            label="Select"
            v-if="SubPage === 'PupilCornea' || SubPage === 'tearheight'"
            ><span
              class="iconfont icon-mousepointershubiao"
              style="font-size: 70px; position: relative; bottom: 10px"
            ></span
          ></el-radio-button>
          <el-radio-button
            label="Eraser"
            v-if="SubPage !== 'PupilCornea' && SubPage !== 'meibomian'"
            ><span class="el-icon-delete"></span
          ></el-radio-button>
          <el-radio-button label="Restore" v-if="SubPage === 'PupilCornea'"
            ><span class="el-icon-refresh-left"></span
          ></el-radio-button>
          <el-radio-button v-if="SubPage === 'tearheight'" label="Height"
            ><span class="el-icon-edit"></span
          ></el-radio-button>
          <el-radio-button v-if="SubPage === 'tearheight'" label="AutoHeight"
            ><span class="el-icon-thumb"></span
          ></el-radio-button>
          <el-radio-button v-if="SubPage === 'meibomian'" label="Meibomian"
            ><span class="iconfont icon-Lasso-Tool" style="font-size: 70px; line-height: 0.5"></span
          ></el-radio-button>
        </el-radio-group>
        &nbsp;&nbsp;&nbsp;
        <el-select
          size="medium"
          v-if="!SubPage === 'tearheight'"
          v-model="currentUnit"
          @change="selUnit"
          style="width: 100px"
        >
          <el-option
            v-for="item in selectUnit"
            style="height: 40px"
            :key="item"
            :value="item"
            :label="item"
          >
          </el-option>
        </el-select>
        <el-color-picker
          v-if="SubPage === 'nibut'"
          @change="changeColor"
          v-model="graphColor"
          style="margin-left: 10px; margin-right: 10px"
        ></el-color-picker>
      </el-row>
    </el-main>
  </div>
</template>
<script>
export default {
  name: "drawType",
  props: {
    toolsBoxWidth: Number,
    toolsBoxHeight: Number,
    SubPage: String,
    value: {
      type: String,
      default: "Select"
    },
    curImg: String
  },
  data: function () {
    return {
      radio: 1,
      graphMode: "Select",
      graphColor: "#00FF00",
      currPaper: undefined,
      currDispID: undefined,
      loading: false,
      dispWindowCount: 1,
      setZoom: 1,
      setLeftOffset: 0,
      setTopOffset: 0,
      isLinkZoom: false,
      selectUnit: { noMeasureMark: "N/A", millimetre: "mm" },
      currentUnit: "mm",
      markcfg: {}
    };
  },
  methods: {
    changeGraphMode: function () {},
    radioChangeTool(val) {
      // this.$emit('btnDrawToolChange', val)
      this.$emit("input", val);
    },
    radioChangeEyeRedness(val) {},
    changeColor: function (color) {
      this.graphColor = color;

      this.$emit("colorChangeTearHeight", color);
    },
    selUnit: function () {
      this.markcfg.MeasureMark = this.currentUnit;
      this.$emit("unitChangeTearHeight", this.currentUnit);
    },
    clickBtnTrash() {}
  },
  watch: {
    value: function (newVal, old) {
      this.graphMode = newVal;
      if (this.SubPage === "meibomian") {
        this.graphMode = "Meibomian";
        this.$emit("input", "Meibomian");
      }
    },
    curImg: function (newVal) {
      this.curImgType = newVal;
    }
  },
  created: function () {},
  mounted: function () {
    if (this.SubPage === "meibomian") {
      this.graphMode = "Meibomian";
      this.$emit("input", "Meibomian");
    } else {
      this.graphMode = "Select";
    }
  },
  computed: {
    toolsBoxStyle: function () {
      return {
        width: `${this.toolsBoxWidth}px`,
        height: `${this.toolsBoxHeight}px`,
        // marginTop: '20px',
        padding: "0px",
        overflow: "hidden"
      };
    }
  }
};
</script>
<style scoped>
.myradio /deep/ .is-align-middle {
  display: flex !important;
}
.myradio /deep/ .el-input__inner {
  font-size: 20px !important;
  line-height: 40px !important;
  height: 40px !important;
}
/deep/ .el-radio-button__inner {
  background: #3a3b40;
  border-color: #3a3b40;
  padding: 8px 20px;
  border-left: none !important;
  line-height: 80px;
  height: 80px;
  font-size: 68px;
}
/deep/ .el-radio-group {
  line-height: 4;
}
.el-radio-button__inner span {
  vertical-align: top !important;
}
</style>



// WEBPACK FOOTER //
// src/common/components/drawType.vue